module.exports = __webpack_public_path__ + "prod/1.42.2/img/obj_integrators2x.3d7315e8.png";